/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/self-closing-comp */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './css/TourLoader.css';

function TourLoader() {
  return (
    <div className="tour_item">
      <div className="tr_hotel_image_w">
        <Skeleton height="100%" />
      </div>

      <div className="tr_tour_info_w">
        <div className="tr_tour_info">
          <div className="tr_hotel_info_w2">
            <div className="tr_hotels_stars_w1">
              <Skeleton height="14px" width="80px" />
              <div className="tr_hotel_name">
                <Skeleton height="22px" width="200px" />
              </div>

              <div className="tr_location">
                <Skeleton height="12px" width="140px" />
              </div>
            </div>

            <div>
              <Skeleton />
            </div>
          </div>

          <div className="mb_20">
            <div className="tr_hotel_description_item">
              <Skeleton height="12px" width="100%" />
            </div>
            <div className="tr_hotel_description_item">
              <Skeleton height="12px" width="90%" />
            </div>
            <div className="tr_hotel_description_item">
              <Skeleton height="12px" width="60%" />
            </div>
          </div>

          <Skeleton height="36px" width="160px" />
        </div>

        <div className="tr_tour_price_info">
          <div>
            <div className="tr_tour_det_line tr_black_text">
              <Skeleton height="12px" width="60%" />
            </div>
            <div className="tr_tour_det_line tr_black_text">
              <Skeleton height="12px" width="60%" />
            </div>
          </div>
          <Skeleton height="48px" borderRadius="12px" />
        </div>
      </div>
    </div>
  );
}

export default TourLoader;
